import { matchPath } from "react-router-dom";
import { APP_ROUTES } from "../../../system/router/constants";

export const popFromUrl = (path) => path.split("/").slice(-1).pop();
export const isNumeric = (num) => !isNaN(num);

export const arrayRemove = (arr, value) => arr.filter((el) => el !== value);

export const arrayRemoveByValues = (arr, values) =>
  arr.filter((el) => !values?.includes(el));

const disableTitleItems = [
  "brands",
  "all-games",
  "providers",
  "categories",
  "promotions",
  "banners",
  "faqs",
  "pages",
  "news",
  "tournaments",
  "terms",
  "images-pack",
  "file-storage",
  "gateways",
  "services",
  "deposit",
  "withdrawal",
  "quiz",
  "bonus distribution",
  "calendars",
  "brand settings",
  "roles",
  "app-management",
  "notification-campaigns",
  "notification-categories",
  "gamification",
  "point-games",
  "bonus-distribution",
  "referral-program",
]; // add title name here if you want to remove title with back navigation btn
export const disableTitle = (title) => {
  return !!title && !disableTitleItems.includes(title.toLowerCase());
};

export const SET_BREADCRUMBS = "SET_BREADCRUMBS";
export const REMOVE_BREADCRUMBS = "REMOVE_BREADCRUMBS";

export type breadcrumbType = {
  path: string;
  title: string;
  root?: boolean;
};

export type breadcrumbsDataType = breadcrumbType[] | null;

export const nestedRoutesWithMenu = [
  APP_ROUTES.gamification,
  APP_ROUTES.pointGames,
  APP_ROUTES.level,
];
export const customBreadcrumbsRoutes = [...nestedRoutesWithMenu];

export const isNestedRouteWithMenu = (pathname: string) =>
  nestedRoutesWithMenu.some((path) => matchPath(path, pathname));

export const isCustomBreadcrumbs = (pathname: string) =>
  customBreadcrumbsRoutes.some((path) => matchPath(path, pathname));
